import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-presentation-button',
  templateUrl: './presentation-button.component.html',
  styleUrls: ['./presentation-button.component.scss']
})
export class PresentationButtonComponent implements OnInit {
  @Input() isActive:boolean;
  
  constructor() { }

  ngOnInit(): void {
  }

}
